import { render } from "./PersonalGoalCheckInModal.vue?vue&type=template&id=047e60f3&ts=true"
import script from "./PersonalGoalCheckInModal.vue?vue&type=script&lang=ts"
export * from "./PersonalGoalCheckInModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__